interface DanmakuConfig {
  show: boolean
  shields: string[]
  opacity: number
  limitArea: number
  fontScale: number
  speed: number
  keepOutSubtitle: boolean
}

let config: DanmakuConfig = {
  show: true,
  shields: [],
  opacity: 0.8,
  limitArea: 4,
  fontScale: 1,
  speed: 1,
  keepOutSubtitle: false
}

export function useDanmakuConfig() {
  function getConfig() {
    if (localStorage) {
      const configStr = localStorage.getItem('playerDanmakuConfigV2')
      if (configStr) {
        config = JSON.parse(configStr)
      }
    }
    return config
  }

  function updateConfig(key: keyof DanmakuConfig, value: boolean) {
    config[key] = value as never
    if (localStorage) {
      localStorage.setItem('playerDanmakuConfigV2', JSON.stringify(config))
    }
  }

  return {
    getConfig,
    updateConfig
  }
}
